import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Site\GetSiteByIdController::__invoke
* @see app/Http/Controllers/Site/GetSiteByIdController.php
* @route '/api/site/{site}'
*/
const GetSiteByIdController = (args: { site: string | number | { id: string | number } } | [site: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSiteByIdController.url(args, options),
    method: 'get',
})

GetSiteByIdController.definition = {
    methods: ["get","head"],
    url: '/api/site/{site}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Site\GetSiteByIdController::__invoke
* @see app/Http/Controllers/Site/GetSiteByIdController.php
* @route '/api/site/{site}'
*/
GetSiteByIdController.url = (args: { site: string | number | { id: string | number } } | [site: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { site: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { site: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            site: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        site: typeof args.site === 'object'
        ? args.site.id
        : args.site,
    }

    return GetSiteByIdController.definition.url
            .replace('{site}', parsedArgs.site.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Site\GetSiteByIdController::__invoke
* @see app/Http/Controllers/Site/GetSiteByIdController.php
* @route '/api/site/{site}'
*/
GetSiteByIdController.get = (args: { site: string | number | { id: string | number } } | [site: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSiteByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Site\GetSiteByIdController::__invoke
* @see app/Http/Controllers/Site/GetSiteByIdController.php
* @route '/api/site/{site}'
*/
GetSiteByIdController.head = (args: { site: string | number | { id: string | number } } | [site: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetSiteByIdController.url(args, options),
    method: 'head',
})

export default GetSiteByIdController